// extracted by mini-css-extract-plugin
module.exports = {"pageName":"NotFound404_pageName__13iAd","main404":"NotFound404_main404__3radN","backGif":"NotFound404_backGif__1TQNK"};